import { render, staticRenderFns } from "./DownloadPublicFile.vue?vue&type=template&id=78c0d9f2&"
import script from "./DownloadPublicFile.vue?vue&type=script&lang=js&"
export * from "./DownloadPublicFile.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPublicFile.vue?vue&type=style&index=0&id=78c0d9f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports